export const consts = {
  TOKEN_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token'
};

export const BASEDATA_FIELD = [
  { type: 'IVT', dataField: 'ivtData', dataFieldSum: 'ivtDataSum' },
  { type: 'ACB', dataField: 'acbData', dataFieldSum: 'acbDataSum' },
  { type: 'VCB', dataField: 'vcbData', dataFieldSum: 'vcbDataSum' }
];

export const REPORT_TYPE = [
  { value: 'daily', label: '일보' },
  { value: 'weekly', label: '주보' },
  { value: 'monthly', label: '월보' },
  { value: 'yearly', label: '연보' }
];

export const DEVICE_TYPES = [
  { value: 'ALL', label: '전체' },
  { value: 'IVT', label: 'IVT' },
  { value: 'ACB', label: 'ACB' },
  { value: 'VCB', label: 'VCB' }
];

export const FIELD_NAMES = [
  {
    v: 'IVT',
    n: '인버터',
    each: 'ivtData',
    tally: 'ivtDataSum',
    type: 'ivt'
  },
  {
    v: 'ACB',
    n: 'ACB',
    each: 'acbData',
    tally: 'acbDataSum',
    type: 'grid'
  },
  {
    v: 'VCB',
    n: 'VCB',
    each: 'vcbData',
    tally: 'vcbDataSum',
    type: 'grid'
  }
];
